export default __webpack_public_path__ + "static/media/Sume_Premio_EdificiosComerciales.7aef43e5.png";